export default "__VITE_ASSET__600d2fff__"